import React from "react";
import { ASSETS } from "../config/assets";

const Support = () => {
  return (
    <div className="container-fluid">
      <div className="row mb-4">
        <div className="col">
          <h1 className="h3 mb-0">Support</h1>
          <p className="text-muted">Get help and support for {ASSETS.brandName} APIs</p>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-body">
              <h5>Support Center</h5>
              <p>
                Help documentation, FAQs, and support ticket features will be
                implemented here.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
